var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { getIn, useFormikContext } from "formik";
import React from "react";
import { AutoComplete } from "../components";
import { OverflowingTypography, Stack, Typography, } from "@vividtheory/minerva-lab";
import { CountryIcon } from "../icons";
import { getCountryFromString } from "@biggeo/bg-utils";
export const FormikSingleSelect = (_a) => {
    var _b, _c;
    var { name, edit, label, startNode } = _a, props = __rest(_a, ["name", "edit", "label", "startNode"]);
    const formik = useFormikContext();
    const touched = getIn(formik.touched, name);
    const error = getIn(formik.errors, name);
    const _value = getIn(formik.values, name);
    const textValue = props.useValueAsKey
        ? (_c = (_b = props.options) === null || _b === void 0 ? void 0 : _b.find((o) => o.value === _value)) === null || _c === void 0 ? void 0 : _c.label
        : _value;
    const country = name.toLowerCase() === "country"
        ? getCountryFromString(_value)
        : undefined;
    const icon = country ? React.createElement(CountryIcon, { country: country }) : startNode;
    return edit ? (React.createElement(AutoComplete, Object.assign({ value: _value, error: touched && !!error, errorText: touched ? error : "", label: label, startNode: startNode, onOptionSelect: (option) => {
            formik.setFieldValue(name, option.label);
        } }, props))) : (React.createElement(Stack, { gap: 2 },
        React.createElement(Typography, { variant: "textFieldLabel" }, label),
        React.createElement(Stack, { flexDirection: "row", gap: 1, alignItems: "center" },
            icon,
            React.createElement(OverflowingTypography, { variant: "body2", fontWeight: "semibold" }, textValue))));
};
//# sourceMappingURL=FormikSingleSelect.js.map